import { useContext, useState } from 'react'

import { useSelector } from 'react-redux'
import Cookie from 'js-cookie'
import { Alert, Button, Form, Input, Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons'
import { faAt } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import {
  DEFAULT_DATA,
  InternshipRequestPortalFormContext, Modes
} from '../../Providers/Forms/InternshipRequestPortal/InternshipRequestPortalFormProvider'
import { RequestPortalContext } from '../../Providers/RequestPortalProvider'
import FormItem from '../../Components/shared/Forms/FormItem'
import { isValid } from '../../utils/validators'
import { StudentValidators } from '../../utils/entities/student'
import { getRedirectAction } from '../../utils/api/student'
import { Cookies } from '../../utils/Cookie'
import { StorageKeys } from '../../Providers/AuthProvider'
import { RedirectActions } from '../../Providers/Forms/InternshipRequestPortal/RedirectStudentModal'
import { Properties } from '../../utils/entities'
import ConfirmFormFooter from '../../Components/antd/Forms/ConfirmFormFooter'
import { HttpStatuses } from '../../utils/http'

const InterneoAccountForm = ({ visible = false, onHasAccount, onPortalRedirection }) => {
  const { setFormHandler } = useContext(InternshipRequestPortalFormContext)
  const { setStudentEmail } = useContext(RequestPortalContext)

  const [email, setEmail] = useState('')
  const [redirectAction, setRedirectAction] = useState('')
  const [errorFields, setErrorFields] = useState([])
  const [isNotFoundEmail, setIsNotFoundEmail] = useState(false)

  const t = useSelector(selectTranslate)

  const searchStudent = email => getRedirectAction(email).then(({ data }) => {
    setStudentEmail(email)

    if (data === RedirectActions.REDIRECTION) {
      handleRedirectToLogin()
    } else {
      setRedirectAction(data)
    }
  }).catch(response => setIsNotFoundEmail(response.status === HttpStatuses.NOT_FOUND))

  const handleEmailChange = event => {
    const email = event.target.value

    if (isNotFoundEmail) {
      setIsNotFoundEmail(false)
    }

    setEmail(email)
  }

  const handleEmailSubmit = event => {
    event.preventDefault()

    // A trailing space is invisible in the field and used to make the lookup answer "compte
    // introuvable" on a perfectly existing account: validate and search the trimmed address.
    const trimmedEmail = email.trim()

    const errorFields = isValid({ email: trimmedEmail }, [StudentValidators.email]).keys

    setErrorFields(errorFields)

    if (errorFields.length === 0) {
      searchStudent(trimmedEmail)
    }
  }

  const handleRedirectToLogin = () => {
    Object.values(Cookies).forEach(value => Cookie.remove(value))
    window.localStorage.removeItem(StorageKeys.ACCOUNT_ID)
    onHasAccount()
  }

  const handleRedirectToPortal = mode => {
    onPortalRedirection(mode)
    setFormHandler({ data: DEFAULT_DATA[mode], mode })
  }

  const handleCancel = () => setRedirectAction('')

  const className = field => errorFields.includes(field) ? 'error-ant-border' : ''

  if (!visible) {
    return null
  }

  return (
    <>
      <Modal
        title={t('activation_redirect_account.title')}
        visible={redirectAction === RedirectActions.WITH_REMINDER}
        centered
        footer={(
          <ConfirmFormFooter
            confirmTitle={t('activation_redirect_account.confirm.title')}
            cancelTitle={t('activation_redirect_account.cancel.title')}
            confirmClassName='logo-colored-button blue-ghost blue-hover'
            cancelClassName='logo-colored-button gray-ghost gray-hover'
            onCancel={handleCancel}
            onConfirm={handleRedirectToLogin}
          />
        )}
        onCancel={handleCancel}
      >
        <Alert
          description={t('activation_redirect_account.account_explanation')}
          type='warning'
          showIcon
          icon={<FontAwesomeIcon icon={faTriangleExclamation} />}
        />
        <br />
        <span>{t('activation_redirect_account.email_explanation', { buttonTitle: t('activation_redirect_account.confirm.title') })}</span>
      </Modal>
      <Form className='login-form h-100-i'>
        <div className='flex-col h-100'>
          <FormItem label='interneo_account_form.questions.has_account'>
            <Input
              prefix={<FontAwesomeIcon icon={faAt} style={{ color: 'rgba(0,0,0,.25)' }} />}
              className={className(Properties.EMAIL)}
              value={email}
              onChange={handleEmailChange}
            />
            {isNotFoundEmail && (
              <>
                <span className='input-error'>{t('login_lookup.error.404')}</span>
                <br />
              </>
            )}
            <Button
              className='flex-fill logo-colored-button blue blue-ghost-hover mt-4 w-100'
              type='primary'
              onClick={handleEmailSubmit}
            >
              {t('common.connect')}
            </Button>
          </FormItem>
          <FormItem label='interneo_account_form.questions.no_account'>
            <Button
              className='flex-fill logo-colored-button orange orange-ghost-hover mt-4 w-100'
              hover=''
              type='default'
              onClick={() => handleRedirectToPortal(Modes.STUDENT)}
            >
              {t('common.create_account')}
            </Button>
          </FormItem>
        </div>
      </Form>
    </>
  )
}

export default InterneoAccountForm
